import { createStyles } from '@mui/styles';

export const SignatureRequirementTableStyles = () =>
  createStyles({
    tableContainer: {
      'marginTop': '16px',
      '& tbody tr:nth-child(odd)': {
        backgroundColor: '#edefef',
      },
      '& tbody td': {
        border: '1px solid rgba(224, 224, 224, 1)',
      },
      '& thead th': {
        border: '1px solid rgba(224, 224, 224, 1)',
      },
    },
    parentRow: {
      fontWeight: 600,
    },
    childRow: {
      paddingLeft: '32px',
    },
    indeterminateCheckbox: {
      opacity: 0.6,
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: '32px',
    },
    emptyState: {
      textAlign: 'center',
      padding: '32px',
      color: '#666',
    },
  });
